import React from 'react';
import radium from 'radium';
import { Link as link } from 'react-router';
import Helpers from '../../helpers';

const Link = radium(link);

const styles = {
  wrap: {
    width: '100%',
    height: '100%',
    padding: '36px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 150px)',
  },
  innerBox: {
    width: '100%',
    maxWidth: 800,
    '@media (max-width: 767px)': {
      padding: '0px 15px',
    }
  },
  innerBox_TV: {
    width: '70%',
  },
  headerIcon: {
    fontSize: 90,
    color: '#fbbb0c',
    margin: '0 auto',
    textAlign: 'center',
    width: 90,
    position: 'relative'
  },
  headerIcon_TV: {
    fontSize: 98,
    color: '#fbbb0c',
    margin: '0 auto',
    textAlign: 'center',
    width: 98,
    position: 'relative',
  },
  floatIcon: {
    position: 'absolute',
    top: -6,
    left: -30,
    fontSize: 48,
    transform: 'scaleX(-1)',
  },
  warningList: {
    fontSize: 14,
    letterSpacing: 1,
    color: '#4a4a4a'
  },
  warningList_TV: {
    fontSize: 22,
    letterSpacing: 1,
    color: '#4a4a4a'
  },
  list: {
    padding: '0 0 0 22px',
    margin: '2px 0 0 0',
  },
  warningHelper: {
    margin: 0,
  },
  subtitle: {
    color: '#4a4a4a',
    fontSize: 18,
    letterSpacing: 1,
    fontWeight: 500,
    margin: '24px 0'
  },
  subtitle_TV: {
    color: '#4a4a4a',
    fontSize: 26,
    letterSpacing: 1,
    fontWeight: 500,
    margin: '24px 0',
  },
  procedureTitle: {
    margin: '18px 0',
    color: '#004d9f',
    fontSize: 16
  },
  procedureTitle_TV: {
    margin: '18px 0',
    color: '#004d9f',
    fontSize: 24,
  },
  procedureDesc: {
    fontSize: 14,
    letterSpacing: 1,
    color: '#4a4a4a',
    margin: 0
  },
  procedureDesc_TV: {
    fontSize: 22,
    letterSpacing: 1,
    color: '#4a4a4a',
    margin: 0
  },
  link: {
    margin: '24px auto',
    fontSize: 18,
    color: '#fff',
    backgroundColor: '#fed312',
    letterSpacing: 4,
    width: 260,
    height: 42,
    lineHeight: '42px',
    textDecoration: 'none',
    display: 'block',
    textAlign: 'center',
    padding: '0 0 0 4px',
    cursor: 'pointer'
  },
  linK_TV: {
    margin: '24px auto',
    fontSize: 35,
    color: '#fff',
    backgroundColor: '#fed312',
    letterSpacing: 4,
    width: '60%',
    borderRadius: '5px',
    lineHeight: '80px',
    textDecoration: 'none',
    display: 'block',
    textAlign: 'center',
    padding: '0 0 0 4px', 
    cursor: 'pointer',
  }
};

function DetectionIntro() {
  var innerBox = styles.innerBox;
  var headerIcon = styles.headerIcon;
  var warningList = styles.warningList;
  var subtitle = styles.subtitle;
  var procedureTitle = styles.procedureTitle;
  var procedureDesc = styles.procedureDesc;
  var link = styles.link;

  if (Helpers.Session.isViaTV()) {
    innerBox = styles.innerBox_TV;
    headerIcon = styles.headerIcon_TV;
    warningList = styles.warningList_TV;
    subtitle = styles.subtitle_TV;
    procedureTitle = styles.procedureTitle_TV;
    procedureDesc = styles.procedureDesc_TV;
    link = styles.linK_TV;
  }

  return (
    <div style={styles.wrap}>
      <div style={innerBox}>
        <div style={headerIcon}>
          <span style={styles.floatIcon} className="fa fa-commenting" />
          <span className="fa fa-user" />
        </div>
        <div style={warningList}>
          <p style={styles.warningHelper}>透過聽力檢測系統，您能輕鬆完成聽力測驗，並獲得基礎的聽力評估結果，請留意以下三點：</p>
          <ol style={styles.list}>
            <li style={styles.listItem}>本測驗為篩檢用，無法取代專業聽力檢查。</li>
            <li style={styles.listItem}>為提升測驗準確性，建議優先使用iPad搭配原廠耳機，減少因不同電腦與耳機所造成的誤差。</li>
            <li style={styles.listItem}>請盡量於安靜環境中測驗，減少環境干擾。</li>
          </ol>
        </div>
        <div style={styles.procedureWrap}>
          <h2 style={subtitle}>請按照下列3個步驟完成測驗：</h2>
          <p style={procedureTitle}>1. 生活情境問題</p>
          <p style={procedureDesc}>日常生活中的5種狀況，您曾遭遇過嗎？</p>
          <p style={procedureDesc}>請回答「是」或「否」。</p>
          <p style={procedureTitle}>2. 調整檢測音量</p>
          <p style={procedureDesc}>請按照簡單步驟設定您的耳機音量。</p>
          <p style={procedureTitle}>3. 進行聽力評估：</p>
          <p style={procedureDesc}>請聆聽一系列的測試音頻，來評估您的聽力狀況。</p>
        </div>
        <Link to="/detections/intro/step1" style={link}>開始聽力測驗</Link>
      </div>
    </div>
  );
}

export default radium(DetectionIntro);



// WEBPACK FOOTER //
// ./components/Detections/DetectionIntro.js